import { render } from "./TelaVisualizacaoConvite.vue?vue&type=template&id=48118cde&scoped=true"
import script from "./TelaVisualizacaoConvite.vue?vue&type=script&lang=js"
export * from "./TelaVisualizacaoConvite.vue?vue&type=script&lang=js"

import "./TelaVisualizacaoConvite.vue?vue&type=style&index=0&id=48118cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48118cde"]])

export default __exports__